export const REMINDER = 'Reminder';
export const NOTE = 'Note';
export const MEMO = 'Memo';
export const JOURNAL_TAB_INDEX = 2;
export const JOURNAL_MEMO_TAB_INDEX = 3;
export const JOURNAL_TAB_RENDER_TIMEOUT = 200;
export const TEXT_MAX_LENGTH = 300;
export const MEMO_MAX_CHAR = 300;
export const REMINDER_MAX_CHAR = 300;
